module.exports = __webpack_public_path__ + "img/money.171bb43e.png";